import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {AuthenticationService} from "../authentication.service";
import {Observable} from "rxjs";

@Injectable()
export class AlreadyLoggedIn implements CanActivate {

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router
    ) {}

    canActivate(): Observable<boolean> {
        // Already authenticated
        if(this.authenticationService.authenticated) {
            this.router.navigate(['dashboard']);
            return Observable.of(false);
        }

        // Not yet logged in, check refresh token
        return this.authenticationService.authenticateRefreshToken()
            .map(authenticated => {
                if (authenticated)
                    this.router.navigate(['dashboard']);

                return !authenticated;
            });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/route-can-activates/already-logged-in.service.ts